export default {
  namespaced: true,
  state: {
    selectedDateFormat: "DD-MMM-YYYY",
    isCustomerListActive: true,
  },
  actions: {
    updateDateFormat({ commit }, format) {
      commit("SET_DATE_FORMAT", format);
    },

    toggleCustomerListAction({ commit }, isActive) {
      commit("SET_CUSTOMER_LIST", isActive);
    },
  },
  mutations: {
    SET_DATE_FORMAT(state, format) {
      state.selectedDateFormat = format;
    },

    SET_CUSTOMER_LIST(state, isActive) {
      state.isCustomerListActive = isActive;
    },
  },
  getters: {
    getDateFormat: (state) => state.selectedDateFormat,
  },
};
